// Central registry for design image assets — the ONLY place image paths live.
//
// Files in public/images/ are generated by `npm run images:build`
// (scripts/optimize-images.mjs) from the originals in assets-src/ (gitignored;
// original photos also live in the owner's Google Drive and the Claude Design
// project). To change an image: put the original in assets-src/, rerun the
// script, and commit the optimized output.
export const IMAGES = {
  /** Hero forest photo. */
  forest: "/images/forest.jpg",
  /** Repeating wheat texture strip (alpha top edge). */
  wheat: "/images/wheat.webp",
  /** Band photo for the About section. */
  band: "/images/band.jpg",
  /** Cutout of the three sisters running (hero foreground). */
  girlsCutout: "/images/girls-cutout.webp" as string | null,
  /** Live photos scattered across the concerts-page hero. */
  live: {
    one: "/images/concerts/live-1.webp",
    two: "/images/concerts/live-2.webp",
    three: "/images/concerts/live-3.webp",
    four: "/images/concerts/live-4.webp",
  },
  /** Member avatars — the design's hand-positioned crops. */
  members: {
    mirtel: "/images/members/mirtel.webp",
    mirjam: "/images/members/mirjam.webp",
    katlin: "/images/members/katlin.webp",
  },
} as const;
